module.exports = require("./../../_gen/starling/assets/AssetType");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/assets/AssetType.js
// module id = 150
// module chunks = 0